<script lang="ts">
import Canvas from "./components/canvas.svelte";
import Form from "./components/form.svelte";
import flagData from "./flags.json";
import InfoBlurb from "./components/info-blurb.svx";

let flags = [
    flagData.trans,
    flagData.bi,
    flagData.nb,
    flagData.polyamorous,
];
const setFlags = (arr) => {
    flags = [...arr];
}
let showInfo = false;

let w: number;
</script>

<main>
    <button class="info" on:click={() => showInfo = !showInfo}>?</button>

    {#if showInfo}
        <div class="info-blurb">
            <InfoBlurb />
        </div>
    {:else}
        <div class="canvas-container" bind:clientWidth={w}>
            <Canvas flags={flags} width={w} />
        </div>
        <Form {flags} {setFlags} />
    {/if}
</main>

<style lang="scss">
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;

        .info {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
            border: none;
            border-radius: 1000rem;
            width: 2rem;
            height: 2rem;
            color: $black;
            background-color: $light-gray;
            line-height: 2rem;
            font-size: 1rem;
            cursor: pointer;

            &:hover {
                color: $dark-gray;
                background-color: darken($light-gray, 10%);
            }
            &:active {
                color: $white;
                background-color: $black;
            }

            @media (prefers-color-scheme: dark) {
                background-color: $black;
                color: $gray;

                &:hover {
                    color: $white;
                    background-color: lighten($dark-gray, 20%);
                }
                &:active {
                    color: $black;
                    background-color: $white;
                }
            }
        }

        .info-blurb {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            align-items: center;

            * {
                margin: 0;
            }
        }

        .canvas-container {
            max-width: 100%;
        }
    }
</style>
